import { useIsAuthenticated } from "@azure/msal-react";
import logo from "../assets/images/logo.png";
import "../App.css";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return (
      <div className="logging-container">
        <img src={logo} alt="Niagara Logo" />
        <h3>Loading...</h3>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
